import { Building } from '@carbon/icons-react';
import { defineSection } from '@/app/registry';

/**
 * Клиники и карточка клиники (БО-01, БО-02; роли — DODOC_ADMIN, DODOC_SUPPORT): статус, тариф, модули, использование,
 * индекс здоровья, подписка и условия пилота, карточка пилота и замеры «до», NPS, доступ поддержки, AI, заметки.
 */
export const section = defineSection({
  id: 'backoffice.clinics',
  area: 'backoffice',
  path: 'clinics/*',
  roles: ['DODOC_ADMIN', 'DODOC_SUPPORT'],
  icon: Building,
  titleKey: 'boClinics:title',
  namespaces: ['boSupport', 'boAi', 'boLaunch', 'portal', 'backoffice'],
  navGroup: 'clients',
  order: 10,
  load: () => import('./ClinicsPage'),
});
